import { http } from "../../../utils/http";
import { showSuccessSnackbar, showErrorSnackbar } from "../snackbar/index";
import * as types from "./types";

const initialState = {
  isLoading: false,
};

export const createBookingRequest = () => ({
  type: types.CREATE_BOOKING_REQUEST,
  isLoading: true,
  message: "fetching",
});

export const createBookingSuccess = (response) => ({
  type: types.CREATE_BOOKING_SUCCESS,
  isLoading: false,
  response,
  message: "success",
});

export const createBookingFailure = (errors) => ({
  type: types.CREATE_BOOKING_FAILURE,
  isLoading: false,
  errors,
  message: "failed",
});

export const createBooking = (bookingData) => (dispatch) => {
  dispatch(createBookingRequest());
  return http
    .post("/api/bookings/create/", bookingData)
    .then((res) => {
      dispatch(createBookingSuccess(res));
      dispatch(showSuccessSnackbar("Your booking was made successfully!"));
    })
    .catch((errors) => {
      dispatch(createBookingFailure(errors));
      dispatch(showErrorSnackbar(errors.response.statusText));
    });
};

export const createBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_BOOKING_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
        bookingMessage: action.message,
      };
    case types.CREATE_BOOKING_SUCCESS:
      return {
        ...state,
        response: action.payload,
        isLoading: action.isLoading,
        bookingMessage: action.message,
      };
    case types.CREATE_BOOKING_FAILURE:
      return {
        ...state,
        response: action.response,
        isLoading: action.isLoading,
        bookingMessage: action.message,
      };
    default:
      return { ...state };
  }
};

export default createBookingReducer;
